import { render } from "./front.vue?vue&type=template&id=6c193ce3&scoped=true"
import script from "./front.vue?vue&type=script&lang=js"
export * from "./front.vue?vue&type=script&lang=js"

import "./front.vue?vue&type=style&index=0&id=6c193ce3&lang=scss&scoped=true"

import exportComponent from "/Users/hou/Desktop/zijie/sdxlxh_user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c193ce3"]])

export default __exports__